import { styled } from 'styled-components';
import { EmptyView } from '@idaho-aeyc/ui-kit';

export const SEmptyView = styled(EmptyView)``;
